<textarea
  #textArea
  qmBlock
  [placeholder]="vm.placeHolder"
  [ngModel]="value"
  [rows]="vm.rows"
  [attr.data-testid]="vm.dataTestId"
  [ngModelOptions]="{ standalone: true }"
  [disabled]="disabled() || formDisabled()"
  (ngModelChange)="textInput($event, textArea)"
  id="text-area"
  [attr.aria-label]="vm.dataLabel"
  [class.keyboard-focus]="showKeyboardFocus"
  [class.has-error]="hasError()"
  (focus)="onInputFocus()"
  (blur)="onInputBlur()"
></textarea>

@if (showCount()) {
  <span class="character-count">
    <span> {{ value?.length || 0 }}</span
    >/{{ vm.maxCharCount || 200 }}
  </span>
}
